import { Phone, Instagram, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteConfig } from '@/context/SiteConfigContext';
import { MOBILE_QUICK_BAR } from '@/constants/testIds';

// Mobile-only sticky quick-contact bar (Call / Message / Book Now) that
// keeps every conversion action reachable with one tap on small screens.
// The floating round StickyBookNow button is hidden on mobile in favor of
// this bar to avoid overlapping controls.
export const MobileQuickBar = () => {
  const config = useSiteConfig();

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex items-stretch border-t border-[hsl(var(--lxra-border))] bg-[#0A0A0A]/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid={MOBILE_QUICK_BAR.root}
    >
      {config.phone && (
        <a
          href={`tel:${config.phone}`}
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 text-[hsl(var(--lxra-fg))] hover:text-[hsl(var(--lxra-gold))] active:text-[hsl(var(--lxra-gold))] transition-colors duration-200 border-r border-[hsl(var(--lxra-border))]"
          data-testid={MOBILE_QUICK_BAR.call}
        >
          <Phone className="h-5 w-5" />
          <span className="text-[10px] uppercase tracking-[0.1em]">Call</span>
        </a>
      )}
      {config.instagram_url && (
        <a
          href={config.instagram_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 text-[hsl(var(--lxra-fg))] hover:text-[hsl(var(--lxra-gold))] active:text-[hsl(var(--lxra-gold))] transition-colors duration-200 border-r border-[hsl(var(--lxra-border))]"
          data-testid={MOBILE_QUICK_BAR.message}
        >
          <Instagram className="h-5 w-5" />
          <span className="text-[10px] uppercase tracking-[0.1em]">Message</span>
        </a>
      )}
      <Link
        to="/book"
        className="flex-[1.4] flex items-center justify-center gap-2 bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] active:bg-[hsl(var(--lxra-gold-hover))] transition-colors duration-200 text-xs uppercase tracking-[0.1em] font-semibold"
        data-testid={MOBILE_QUICK_BAR.bookNow}
      >
        Book Now
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
};
